// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h5hv","col":"styles_col__1PDw4"};